import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import LogoutButton from './LogoutButton'
import LoadingSpinner from './LoadingSpinner'
import './Header.css'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { isAuthenticated, isLoading, user, login } = useAuth()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleLogin = async () => {
    try {
      await login()
    } catch (err) {
      console.error('Header login error:', err)
    }
  }

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="header-logo">
            <a href="/" className="logo-link" aria-label="MEQ Labs Home">
              <img 
                src="/assets/logo/meq-logo.png" 
                alt="MEQ Labs Logo" 
                className="logo-image"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="header-nav desktop-nav" aria-label="Main Navigation">
            <ul className="nav-list">
              <li><a href="#features" className="nav-link">Features</a></li>
              <li><a href="#about" className="nav-link">About</a></li>
              <li><a href="#contact" className="nav-link">Contact</a></li>
              <li><a href="#help" className="nav-link">Help</a></li>
            </ul>
          </nav>

          {/* User Actions */}
          <div className="header-actions">
            {isAuthenticated ? (
              <div className="user-info">
                <span className="user-name">
                  {user?.name || user?.email || 'User'}
                </span>
                <LogoutButton variant="secondary" size="small" showIcon={false} />
              </div>
            ) : (
              <button 
                className="btn btn-primary"
                type="button"
                aria-label="Login to MEQ Insights"
                onClick={handleLogin}
                disabled={isLoading}
              >
                {isLoading ? <LoadingSpinner size="small" /> : 'Sign In'}
              </button>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-button"
            type="button"
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            onClick={toggleMenu}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav 
          className={`header-nav mobile-nav ${isMenuOpen ? 'mobile-nav-open' : ''}`}
          aria-label="Mobile Navigation"
        >
          <ul className="nav-list">
            <li><a href="#features" className="nav-link" onClick={toggleMenu}>Features</a></li>
            <li><a href="#about" className="nav-link" onClick={toggleMenu}>About</a></li>
            <li><a href="#contact" className="nav-link" onClick={toggleMenu}>Contact</a></li>
            <li><a href="#help" className="nav-link" onClick={toggleMenu}>Help</a></li>
            <li>
              {isAuthenticated ? (
                <div className="mobile-user-info">
                  <span className="mobile-user-name">
                    {user?.name || user?.email || 'User'}
                  </span>
                  <LogoutButton 
                    variant="secondary" 
                    size="medium" 
                    showIcon={false}
                    className="w-full"
                  />
                </div>
              ) : (
                <button 
                  className="btn btn-primary w-full"
                  type="button"
                  onClick={() => {
                    toggleMenu()
                    handleLogin()
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? <LoadingSpinner size="small" /> : 'Sign In'}
                </button>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Header 